import { SVGAttributes } from 'react';

type Props = SVGAttributes<SVGElement>;

export function IconFlip360(props: Props) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="currentColor"
            data-testid="IconFlip360"
            {...props}
        >
            <path d="M15 20L16.4 18.6L14.65 16.8C16.7833 16.5167 18.5417 15.9333 19.925 15.05C21.3083 14.1667 22 13.15 22 12C22 10.6167 21.0375 9.4375 19.1125 8.4625C17.1875 7.4875 14.8167 7 12 7C9.18333 7 6.8125 7.4875 4.8875 8.4625C2.9625 9.4375 2 10.6167 2 12C2 13.0333 2.55417 13.9583 3.6625 14.775C4.77083 15.5917 6.21667 16.2 8 16.6V14.55C6.71667 14.2167 5.72917 13.8042 5.0375 13.3125C4.34583 12.8208 4 12.3833 4 12C4 11.4667 4.7125 10.8333 6.1375 10.1C7.5625 9.36667 9.51667 9 12 9C14.4833 9 16.4375 9.36667 17.8625 10.1C19.2875 10.8333 20 11.4667 20 12C20 12.4 19.575 12.8792 18.725 13.4375C17.875 13.9958 16.6667 14.4167 15.1 14.7L16.4 13.4L15 12L11 16L15 20Z" />
        </svg>
    );
}
